/*
  Article page: reading progress bar, "On this page" scroll-spy with smooth scrolling, and "Copy link".
*/
(() => {
  const bar = document.querySelector('[data-sok-progress]');
  const body = document.querySelector('[itemprop="articleBody"]')?.closest('.sok-article__main');
  const toc = document.querySelector('[data-sok-toc]');
  const links = toc ? [...toc.querySelectorAll('a[href^="#"]')] : [];
  const targets = links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))));
  let ticking = false;

  const update = () => {
    ticking = false;
    const vh = window.innerHeight;
    if (bar && body) {
      const rect = body.getBoundingClientRect();
      const total = Math.max(1, rect.height - vh * 0.5);
      const pct = Math.max(0, Math.min(1, (-rect.top + vh * 0.3) / total));
      bar.style.transform = `scaleX(${pct})`;
    }
    let active = 0;
    targets.forEach((el, i) => {
      if (el && el.getBoundingClientRect().top < vh * 0.35) active = i;
    });
    links.forEach((link, i) => {
      link.classList.toggle('is-active', i === active);
      if (i === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  window.addEventListener('resize', update);
  update();

  links.forEach((link, i) =>
    link.addEventListener('click', (event) => {
      const el = targets[i];
      if (!el) return;
      event.preventDefault();
      const top = el.getBoundingClientRect().top + window.scrollY - 90;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', link.hash);
      el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    })
  );

  document.querySelectorAll('[data-sok-copy-link]').forEach((button) => {
    const idle = button.textContent;
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(location.href.split('#')[0]);
      } catch (e) {}
      button.textContent = button.dataset.copied;
      clearTimeout(button.timer);
      button.timer = setTimeout(() => (button.textContent = idle), 1800);
    });
  });
})();
